import { useLocation } from "react-router-dom";
import $ from "jquery"
import { useRef, useState } from "react";
import ModalEditeEcriture from "./ModalEditeEcriture";
import UseFetch from "../components/UseFetch";
import { decryptData } from "../components/const";

const Detail = () => {

    const location = useLocation()
    const { par } = location.state
    const tableRef = useRef()
    const [selected, setSelected] = useState(null)
    const { data, isloading } = UseFetch(`confier/partenaire/${par.id}`)
    const user = decryptData("USER")
    $(tableRef.current).DataTable()
    return (
        <div className="container">


            {isloading && <div className="loader"></div>}
            <h3 className="text-secondary">Detail des opérations de [{par.nom_complet?.toUpperCase()}]</h3>
            {(data?.operations?.length > 0) ? <div className="table-responsive my-2">

                <div className="row justify-content-center bg-secondary-subtle">
                    <div className="col-lg-2 card shadow border-0 p-1 text-center m-1">
                        Total Depot
                        <span className="fw-bold">
                            {data?.depot?.toLocaleString()} {data?.devise}
                        </span>
                    </div>
                    <div className="col-lg-2 card shadow border-0 p-1 text-center m-1 bg-danger-subtle">
                        Total retrait
                        <span className="fw-bold">
                            {data?.retrait?.toLocaleString()} {data?.devise}
                        </span>
                    </div>
                    <div className={`col-lg-2 card shadow border-0 p-1 text-center m-1`}>
                        Solde
                        <span className="fw-bold">
                            {data?.solde?.toLocaleString()} {data?.devise}
                        </span>
                    </div>
                </div>


                <table ref={tableRef} className="table table-hover table-hover table-bordered">
                    <thead className="table-dark">
                        <tr>
                            <th>N°</th>
                            <th>MONTANT</th>
                            <th>TYPE</th>
                            <th>COMMENTAIRES</th>
                            <th>DATE</th>
                            {user.droit == "Comptable" && <th>ACTIONS</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.operations?.map((op, ind) =>
                                <tr key={ind} className={op.montant < 0 ? "bg-danger-subtle" : ''}>
                                    <td>{ind + 1}</td>
                                    <td>{op.montant?.toLocaleString()} {op.devise}</td>
                                    <td>{op.montant > 0 ? "Depot" : "Retrait"}</td>
                                    <td>{op.commentaire}</td>
                                    <td>{op.created_at}</td>
                                    {user.droit == "Comptable" && <td>
                                        <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modal-edite-ecriture" onClick={() => setSelected(op)}>
                                            <span className="bx bx-edit"></span>
                                        </button>
                                    </td>}
                                </tr>
                            )
                        }
                    </tbody>
                </table>


            </div> : !isloading && <div className="text-center p-2 text-danger bg-danger-subtle fs-5">Aucune operation pour cet élément</div>}

            <ModalEditeEcriture operation={selected} />
        </div>
    );
}

export default Detail;